<template>
  <div class="text-13 h-6 flex items-center">
    Send Email using&nbsp;
    <span class="font-600">{{ emailTemplate }}</span>
    &nbsp;to&nbsp;
    <span class="font-600">{{ emailTo }}</span>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'EmailOverview',
  props: {
    item: Object,
    evaluate: Array,
  },
  computed: {
    ...mapGetters(['getProjectTemplates']),
    payload() {
      return this.item.payload;
    },
    emailTemplate() {
      return this.getProjectTemplates()?.[this.payload?.email_template]?.name || '';
    },
    emailTo() {
      return this.payload?.to?.[0] || '';
    },
  },
};
</script>
